//utilities
import React, { useEffect, useState } from "react";
import APIURL from "../../APIURL";
import useSWR from "swr";
import { useSelector } from "react-redux";
// SUPPLIER

//kendo component

import { GridPDFExport } from "@progress/kendo-react-pdf";
import { SvgIcon } from "@progress/kendo-react-common";
import { pencilIcon } from "@progress/kendo-svg-icons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { process } from "@progress/kendo-data-query";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { filterBy } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Loader } from "@progress/kendo-react-indicators";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";

//localization
import { useLocalization } from "@progress/kendo-react-intl";

//access
import { useHistory } from "react-router-dom";

//Component
import PermissionDenied from "../../common/commoncomponents/PermissionDenied";
import { CustomColumnMenu } from "../../common/Kendo/CustomColumnMenu";
import Settings from "../../setting/Settings";

export function ListRole(props) {
  //REDUX
  const EditUserSetting = useSelector((state) => state.EditUserSetting);
  const AddUserSetting = useSelector((state) => state.AddUserSetting);

  //PERMISSION DIALOG
  const [NoPermission, setNoPermission] = useState("");
  const [VPermission, setVPermission] = useState(false);

  const toggleDPermission = () => {
    setVPermission(!VPermission);
  };

  //data lead fetching
  const { data: roles, error } = useSWR(APIURL + "/auth/allroles/");

  //localization
  const localizationService = useLocalization();

  //NOTIFICATION
  const [state, setState] = React.useState({
    success: false,
    added: false,
    edited: false,
    error: false,
    warning: false,
    info: false,
    none: false,
  });
  const { success, added, edited } = state;
  const position = {
    topCenter: {
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  };
  //access
  const history = useHistory();

  //multiple selection
  const [selected, setselected] = useState([]);
  const selectField = "selected";
  // FILTER PART
  const [filter, setFilter] = useState();

  const createDataState = (dataState) => {
    return {
      result: roles ? process(roles.slice(0), dataState) : [],
      dataState: dataState,
    };
  };
  let initialState = createDataState({
    take: 8,
    skip: 0,
  });

  let _pdfExport;
  let _export;

  const excelExport = () => {
    _export.save();
  };

  const exportPDF = () => {
    _pdfExport.save();
  };

  const columns = [
    {
      title: localizationService.toLanguageString("custom.rolename"),
      field: "role_name",
      show: true,
      filter: "text",
    },
  ];
  const [data, setData] = useState(initialState.result);
  const [dataState, setDataState] = React.useState(initialState.dataState);
  const [stateColumns, setStateColumns] = React.useState(columns);

  useEffect(() => {
    if (roles) setData(process(roles ? roles.slice(0) : [], dataState));
    if (props.location.add && props.location.add === "edited")
      setState({ edited: true });
    if (props.location.add && props.location.add === "added")
      setState({ added: true });
    setTimeout(() => {
      setState({ added: false, edited: false });
    }, 3000);
  }, [roles]);

  const dataStateChange = (event) => {
    let updatedState = createDataState(event.dataState);
    setData(updatedState.result);
    setDataState(updatedState.dataState);
  };

  //action button
  const ActionTemplate = (props) => {
    return (
      <td>
        <span title={localizationService.toLanguageString("custom.edit")}>
          <SvgIcon
            className="mr-2em EditActionButtons"
            icon={pencilIcon}
            onClick={() => {
              setNoPermission("editnoaccess");
              EditUserSetting
                ? history.push({
                    pathname: "/settings/authentication/role/edit",
                    state: props.dataItem,
                  })
                : toggleDPermission();
            }}
          />
        </span>
      </td>
    );
  };

  // FILTER PART
  const filterChange = (event) => {
    setData(
      process(roles ? filterBy(roles.slice(0), event.filter) : [], dataState)
    );

    setFilter(event.filter);
  };

  const onColumnsSubmit = (columnsState) => {
    setStateColumns(columnsState);
  };

  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">
        {localizationService.toLanguageString("custom.loading")}
      </span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );

  return (
    <Settings>
      {!roles && loadingPanel}
      <Tooltip
        openDelay={0}
        anchorElement="target"
        position="bottom"
        parentTitle="true"
      >
        <NotificationGroup style={position.topCenter}>
          <Fade>
            {added && (
              <Notification
                type={{
                  style: "success",
                  icon: true,
                }}
                closable={true}
                onClose={() => setState({ ...state, added: false })}
              >
                <span>
                  {localizationService.toLanguageString("custom.roleadded")}
                </span>
              </Notification>
            )}
          </Fade>
          <Fade>
            {edited && (
              <Notification
                type={{
                  style: "edited",
                  icon: true,
                }}
                closable={true}
                onClose={() => setState({ ...state, edited: false })}
              >
                <span>
                  {localizationService.toLanguageString("custom.roleedited")}
                </span>
              </Notification>
            )}
          </Fade>
        </NotificationGroup>
        <ExcelExport
          data={data}
          ref={(exporter) => {
            _export = exporter;
          }}
        >
          <Grid
            data={data}
            {...dataState}
            onDataStateChange={dataStateChange}
            sortable={true}
            pageable={true}
            pageSize={8}
            filterable={true}
            filter={filter}
            onFilterChange={filterChange}
          >
            <GridToolbar>
              <div className="col h5 titles-all-page">
                {localizationService.toLanguageString("custom.roles")}
              </div>
              <div className="float-right">
                <Button
                  primary={true}
                  onClick={() => {
                    setNoPermission("addnoaccess");
                    AddUserSetting
                      ? props.history.push("/settings/authentication/role/add")
                      : toggleDPermission();
                  }}
                >
                  {localizationService.toLanguageString("custom.new")}
                </Button>
              </div>
            </GridToolbar>
            {stateColumns.map(
              (column, idx) =>
                column.show && (
                  <Column
                    key={idx}
                    field={column.field}
                    title={column.title}
                    filter={column.filter}
                    cell={column.cell}
                    columnMenu={(props) => (
                      <CustomColumnMenu
                        {...props}
                        columns={stateColumns}
                        onColumnsSubmit={onColumnsSubmit}
                      />
                    )}
                  />
                )
            )}
            <Column
              className="ActionColumn"
              title={localizationService.toLanguageString("custom.actions")}
              cell={(props) => ActionTemplate(props)}
              filterable={false}
              width="100px"
            />
          </Grid>
        </ExcelExport>

        <GridPDFExport
          ref={(element) => {
            _pdfExport = element;
          }}
          margin="1cm"
        >
          {
            <Grid data={data}>
              {stateColumns.map(
                (column, idx) =>
                  column.show && (
                    <Column
                      key={idx}
                      field={column.field}
                      title={column.title}
                      filter={column.filter}
                      cell={column.cell}
                      columnMenu={(props) => (
                        <CustomColumnMenu
                          {...props}
                          columns={stateColumns}
                          onColumnsSubmit={onColumnsSubmit}
                        />
                      )}
                    />
                  )
              )}
              <Column
                className="ActionColumn"
                title={localizationService.toLanguageString("custom.actions")}
                cell={(props) => ActionTemplate(props)}
                filterable={false}
                width="100px"
              />
            </Grid>
          }
        </GridPDFExport>

        {/* PERMISSION DIALOG */}
        {VPermission && (
          <Dialog
            title={localizationService.toLanguageString(
              "custom.permissiondenied"
            )}
            onClose={toggleDPermission}
          >
            <PermissionDenied
              onClose={toggleDPermission}
              NoPermission={NoPermission}
            />
          </Dialog>
        )}
      </Tooltip>
      <NotificationGroup style={position.topCenter}>
        <Fade>
          {added && (
            <Notification
              type={{
                style: "success",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, added: false })}
            >
              <span>
                {localizationService.toLanguageString("custom.roleadded")}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {edited && (
            <Notification
              type={{
                style: "edited",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, edited: false })}
            >
              <span>
                {localizationService.toLanguageString("custom.roleedited")}
              </span>
            </Notification>
          )}
        </Fade>
      </NotificationGroup>
    </Settings>
  );
}

export default ListRole;
